import { render } from "./ReportNextStepPromotionCard.vue?vue&type=template&id=20e34501&scoped=true"
import script from "./ReportNextStepPromotionCard.vue?vue&type=script&lang=js"
export * from "./ReportNextStepPromotionCard.vue?vue&type=script&lang=js"

import "./ReportNextStepPromotionCard.vue?vue&type=style&index=0&id=20e34501&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e34501"]])

export default __exports__